import Component from './Component'

export default class List extends Component {

	static _type = 'List'

	_name
	_list
	map
	filter_regex = null
	search_fields = []
	sort_order = []

	constructor (name, list, search_fields, template, params = {}) {
		super(params)
		this._name = name
		this._list = list
		this.search_fields = search_fields
		this.template = template
	}

	tether () {
		super.tether()

		// Begin the preprocessor
		this.preprocess()
	}

	get name () { return this._name }

	get list () { return this._list }
	set list (value) {
		this._list = value

		// Begin the preprocessor
		this.preprocess()
	}

	// Preprocess
	preprocess () {

		// Begin component update with filter step
		this.filter()
	}

	// Update: step 1
	filter (expression = null) {

		// If we get a new expression, let's prepare it first
		if (expression !== null) {

			// Sanitize
			expression = (expression + '').trim()

			// Convert to regexp
			if (expression == '') {
				// Empty expression
				this.filter_regex = null
			} else {
				// Useful expression
				let exp = ''
				for (let char of expression) {
					// Multi-char substitution
					if (char == '*') {
						exp += '.{1,}'
						continue
					}
					// Single-char substitution
					if (char == '?') {
						exp += '.'
						continue
					}
					// Regex special characters
					if (['\\', '^', '$', '.', '|', '?', '*', '+', '(', ')', '[', ']', '{', '}'].includes(char)) {
						exp += '\\' + char
						continue
					}
					// Everything else
					exp += char
				}

				this.filter_regex = new RegExp(exp, 'gmi')
			}
		}

		// Apply filter
		if (this.filter_regex === null) {
			// We have no filter regex, just clone the reference array
			this.map = this._list.data.map(x => x)
		} else {
			// Create a filtered reference array
			this.map = this._list.data.filter((row) => {
				// For every row..
				for (let field of this.search_fields) {
					// Check every field for a match
					if (this.filter_regex.test(row[field] + ''))
						// We found a match in this field
						return true
				}

				// No matches in this row
				return false
			})
		}

		// Continue update with sort
		this.sort()
	}

	// Update: step 2
	sort () {

		// Run sort
		this.map.sort((a, b) => {

			for (let item of this.sort_order) {

				// Apply rule
				if (a[item.field] > b[item.field]) return (item.order == 'asc' ? 1 : -1)
				if (a[item.field] < b[item.field]) return (item.order == 'asc' ? -1 : 1)

				// If we reach this point, this rule could not make a distinction, so we go to the next one.
			}

			// Signal, that no distinction could be made
			return 0
		})

		// Continue update with content render
		this.render()
	}

	/* Update: step 3
	 * Re-render the dynamic list contents. This is a virtual renderer implementation.
	 */
	render () {

		// Render all list elements
		Anvil.render(this.template, Object.assign({ items: this.map }, this.params), this.base)
	}

	destroy () {

		this._list = null

		super.destroy()
	}
}
